import AxiosPost from '../../http/Axios';

const SaveChild = async (child, email) => {
  try {
    const childToInsert = {
      ...child,
      email: email,
      createdDate: new Date(),
      createdBy: 'Registration Site',
      modifiedDate: new Date(),
      modifiedBy: 'Registration Site',
    };
    await AxiosPost('/kidlab-reg/children', childToInsert);
  } catch (err) {
    throw new Error(
      'There was an error submitting your registration. Please try again.'
    );
  }
};
export default SaveChild;
